<template>
  <div class="data-range">
      <div class="vx-row">
        <div class="vx-card p-6" style="width:69%; margin-right:1%">
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full">
                <label> <h6>DỮ LIỆU TRONG THÁNG 12/2020</h6></label>
              </div>
            </div>

            <div class="vx-row number" v-if="dataUsingPackage ">
              <div class="vx-col w-full">
                <span>{{dataUsingPackage.businessPackage.totalData}}</span>
              </div>
            </div>

            <div class="vx-row mt-5">
            <div class="vx-col w-full  mt-5">
              <vue-apex-charts
                type=line
                height=266
                :options="revenueComparisonLine.chartOptions"
                :series="revenueComparisonLine.series"/>
            </div>

          </div>
          </div>
        </div>

        <div class="vx-card p-6"  style="width:30%; float:right">
          <div class="vx-col w-full ">
            <span>Thao tác</span>
          </div>
          <div class="vs-row mt-5 cursor-pointer" @click="confirmRequest">
            <feather-icon icon="DatabaseIcon" style="margin-right:10px;width:15px;vertical-align: bottom;"></feather-icon>
            <span>Yêu cầu thêm giới hạn dữ liệu</span>
          </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-card p-6 mt-5" style="width:69%;">
        <div class="vx-col w-full">
          <div class="vx-row">
              <div class="vx-col w-full">
                <label> <h6>DỮ LIỆU TRONG THÁNG 11/2020</h6></label>
              </div>
          </div>
          <div class="vx-row number" v-if="dataUsingPackage">
              <div class="vx-col w-full">
                <span>{{dataUsingPackage.businessPackage.totalData}}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components:{
    VueApexCharts
  },
  data(){
    return {
      dataUsingPackage: null,
      barChartStatus: {
          series: [{
            name: "Số bài đăng",
            data: [42, 530],
          }],
          chartOptions: {
            chart: {
              toolbar: {show: false},
              dropShadow: {
                enabled: true,
                top: 5,
                left: 0,
                blur: 4,
                opacity: 0.10,
              },
            },
            colors: ['#ef476f', '#2da6cb'],
            plotOptions: {
              bar: {
                horizontal: true,
                distributed: true
              }
            },
            dataLabels: {
              enabled: true
            },
            xaxis: {
              categories: ['Tiêu cực', 'Tích cực'],
            },
            yAxis: {},
          }
        },
     revenueComparisonLine: {
          // analyticsData: {
          //   socialNetwork: 42657,
          //   newspaper: 36541,
          //   otherSources: 17069
          // },
          series: [{
            name: "Mạng xã hội",
            data: [4500, 4000, 4800, 7500, 5500, 8000, 6500]
           }
          ],
          chartOptions: {
            chart: {
              toolbar: {show: false},
              dropShadow: {
                enabled: true,
                top: 5,
                left: 0,
                blur: 4,
                opacity: 0.10,
              },
            },
            stroke: {
              //curve: 'smooth',
              //dashArray: [0, 8],
              width: [2, 2, 2],
            },
            grid: {
              borderColor: '#e7e7e7',
            },
            legend: {
              show: true,
            },
            colors: ['#5c6bbf', '#db4437', '#f4b401'],
            fill: {
              type: 'gradient',
              gradient: {
                shade: 'dark',
                inverseColors: false,
                gradientToColors: ['#5c6bbf', '#db4437', '#f4b401'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
              },
            },
            markers: {
              size: 0,
              hover: {
                size: 5
              }
            },
            xaxis: {
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                }
              },
              axisTicks: {
                show: false,
              },
              categories: ['1', '2', '3', '4', '5', '6', '7'],
              axisBorder: {
                show: false,
              },
            },
            yaxis: {
              tickAmount: 5,
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                },
                formatter: function (val) {
                  return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                }
              }
            },
            tooltip: {
              x: {show: false}
            }
          },

        }
  }
},
  async created(){
    this.getUserPackage();
  },
  methods:{
    confirmRequest: function(){
       return this.$vs.dialog({
              type: 'confirm',
              color: 'primary',
              accept:this.requestService,
              title: `Yêu cầu thêm giới hạn dữ liệu`,
              text: `Đang dùng ' ${this.dataUsingPackage.businessPackage.name} ', bạn muốn nâng cấp gói cao hơn?`,
              acceptText: "Tới trang yêu cầu",
              cancelText: "Đóng"
            });
    },
    requestService: function(){
      this.$router.push('/user/package/upgrade').catch(() =>{});
    },
    getUserPackage: function(){
      // this.$business.post('/user-package/using-package').then((response) =>{
      //   this.dataUsingPackage = response.data;
      // })
    }
  }
}
</script>
<style scoped>
.data-range{
  padding: 0px 10px  0px 10px;
}
.number{
  font-size: 25px;
  font-weight: bold;
  margin-top: 10px;
}
</style>
